import { useEffect, useState } from "react";

export const useTimer = (startedAt: number | null, estimatedMs: number) => {
  const [remaining, setRemaining] = useState<number>(0);

  useEffect(() => {
    if (!startedAt) return;

    const tick = () => {
      const elapsed = Date.now() - startedAt;
      const left = Math.max(0, estimatedMs - elapsed);
      setRemaining(left);
    };

    tick();
    const id = setInterval(tick, 500);
    return () => clearInterval(id);
  }, [startedAt, estimatedMs]);

  return remaining;
};
